import type { BridgeMethod, BridgeMethods, BridgeResponse } from './types'

/**
 * Browser stand-in for the Flutter host so screens can be built in desktop Chrome.
 * Set VITE_DEV_ACCESS_TOKEN to a real Django token to hit the real API.
 */
type MockHandlers = {
  [M in BridgeMethod]: (req: BridgeMethods[M]['req']) => Promise<BridgeMethods[M]['res']>
}

const sleep = (ms: number) => new Promise((r) => setTimeout(r, ms))

const handlers: MockHandlers = {
  async getCapabilities() {
    return {
      bridgeVersion: 1,
      appVersion: 'mock',
      platform: 'web',
      methods: Object.keys(handlers) as BridgeMethod[],
    }
  },
  async getSession() {
    await sleep(150)
    return {
      accessToken: import.meta.env.VITE_DEV_ACCESS_TOKEN ?? 'mock-token',
      orgId: import.meta.env.VITE_DEV_ORG_ID ?? 'mock-org',
      user: { id: 'u1', name: 'Dev User', email: 'dev@example.com' },
      locale: 'en',
    }
  },
  async refreshToken() {
    await sleep(100)
    return { accessToken: import.meta.env.VITE_DEV_ACCESS_TOKEN ?? 'mock-token' }
  },
  async ready() {},
  async exit() {
    console.info('[bridge:mock] exit requested')
  },
  async getLocation() {
    await sleep(300)
    return { lat: 13.0827, lng: 80.2707, accuracy: 12 }
  },
  async pickImage() {
    await sleep(300)
    return null
  },
  async openExternal({ url }) {
    window.open(url, '_blank', 'noopener')
  },
  async downloadFile({ url }) {
    window.open(url, '_blank', 'noopener')
  },
  async haptic() {},
  async navigateToVanLoadingSOD(form_id) {
    console.info('[bridge:mock] navigateToVanLoadingSOD form_id=', form_id)
  },
  async navigateToVanLoadingEOD(form_id) {
    console.info('[bridge:mock] navigateToVanLoadingEOD form_id=', form_id)
  },
  async navigateToClient({ temp_id, route_id }) {
    console.info('[bridge:mock] navigateToClient temp_id=', temp_id, 'route_id=', route_id)
  },
  async navigateToDailySummary() {
    console.info('[bridge:mock] navigateToDailySummary')
  },
  async preCheckoutResult({ is_success }) {
    console.info('[bridge:mock] preCheckoutResult is_success=', is_success)
  },
}


export async function mockTransport(
  method: string,
  payload: unknown,
): Promise<BridgeResponse<unknown>> {
  const handler = handlers[method as BridgeMethod] as
    ((req: unknown) => Promise<unknown>) | undefined
  if (!handler) return { ok: false, error: { code: 'NOT_IMPLEMENTED', message: method } }
  try {
    return { ok: true, data: await handler(payload) }
  } catch (e) {
    return { ok: false, error: { code: 'MOCK_ERROR', message: String(e) } }
  }
}
